const getAffiliateIdUrl = (url, id, shouldShowAffiliateId = false) => {
    if (!shouldShowAffiliateId) {
        return url;
    }

    return url && id ? `${url}${url.includes('?') ? '&' : '?'}affiliateId=${id}` : url;
};

export default getAffiliateIdUrl;
